import script from "./InvRoomHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./InvRoomHistory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__